// frontend/src/api/products.js
import client from './client.js';

export const productsAPI = {
  // Получить все товары
  getAll: (params = {}) => {
    return client.get('/products', { params });
  },

  // Получить товар по ID (только UUID)
  getById: (id) => {
    return client.get(`/products/${id}`);
  },

  // Получить похожие товары
  getRelated: (id, limit = 4) => {
    return client.get(`/products/${id}/related`, { params: { limit } });
  },

  // Получить отзывы товара
  getReviews: (id, page = 1, limit = 10) => {
    return client.get(`/products/${id}/reviews`, { params: { page, limit } });
  },

  // Создать товар (админ)
  create: (data) => {
    return client.post('/products', data);
  },

  // Обновить товар (админ)
  update: (id, data) => {
    return client.put(`/products/${id}`, data);
  },

  // Удалить товар (админ)
  delete: (id) => {
    return client.delete(`/products/${id}`);
  },
};